module.exports = __webpack_public_path__ + "img/menu_item2.7174cfad.svg";